import type { WavesChart } from '../wavesChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_VIOLET } from '../builtinPulseMaps/palettes.js';
import { assembleWavesChartFromCircles } from './wavesFromCircles.js';
import audioOnsets from '../circlesBuiltinMaps/audio/heroes.onsets.json' with { type: 'json' };
import normalImported from '../circlesBuiltinMaps/imported/heroes-normal.circles.json' with { type: 'json' };
import hardImported from '../circlesBuiltinMaps/imported/heroes-hard.circles.json' with { type: 'json' };
import extremeImported from '../circlesBuiltinMaps/imported/heroes-extreme.circles.json' with { type: 'json' };

export const HEROES_WAVES_VARIANTS: Record<Variant, WavesChart> = assembleWavesChartFromCircles({
  baseSlug: 'heroes',
  baseTitle: "Heroes Tonight",
  description: "Heroes Tonight by Janji feat. Johnning. Bouncy progressive house, melodic vocal hook.",
  difficulty: 3,
  palette: PALETTE_VIOLET,
  audioSrc: '/audio/waves/heroes.mp3',
  attribution: "\"Heroes Tonight\" by Janji (feat. Johnning) [NCS Release] - https://ncs.io/heroes-tonight",
  mapper: "Fureraba",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 128, offsetMs: 0, totalBeats: 131 },
    hard: { bpm: 128, offsetMs: 0, totalBeats: 131 },
    extreme: { bpm: 128, offsetMs: 0, totalBeats: 131 },
  },
});
